export const BasicInfo = [
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
];

export const UserControl = [
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
  { name: "Basic Info", image: "./assets/img/basic_info.svg" },
];

export const EducationalInfo = [
  { name: "Profile", image: "./assets/img/icons_profile.svg" },
  {
    name: "Reason Did Not Qualify",
    image: "./assets/img/reson_did_not_qualify.svg",
  },
  { name: "Preferred Intake", image: "./assets/img/preferred_intake.svg" },
  { name: "Educational Status", image: "./assets/img/educational_pref.svg" },

  {
    name: "University web Details",
    image: "./assets/img/basic_info.svg",
    link: "/university_website_details",
  },
  {
    name: "University",
    image: "./assets/img/category_study.svg",
    link: "/university",
  },
  {
    name: "Campus",
    image: "./assets/img/basic_info.svg",
    link: "/campus",
  },
  {
    name: "Courses",
    image: "./assets/img/Courses.svg",
    link: "/courses",
  },
  {
    name: "University image Upload",
    image: "./assets/img/basic_info.svg",
    link: "/university_image_upload",
  },
];
